import { useCallback } from 'react';
import constructFromTemplate from '../../CtaCard/constructFromTemplate';
import { selectBapUrlQueryString } from '../../../core/reducers/ui';
import { selectDealer } from '../../../core/reducers/dealer';
import { useAppSelector } from '../../../core/utils';
export const encodeURLSearchParams = (url) => {
    const [baseURL = '', searchParams = ''] = url.split('?');
    if (!searchParams)
        return baseURL;
    const encodedParams = new URLSearchParams(decodeURIComponent(searchParams)).toString();
    const encodedUrl = `${baseURL}?${encodedParams}`;
    return encodedUrl;
};
export const mergeURLSegments = (href, query) => {
    if (!query)
        return href;
    const separator = href.split('?')[1] ? '&' : '?';
    const queryString = query.startsWith('?') ? query.substring(1) : query;
    return `${href}${separator}${queryString}`;
};
/** replaces BAP tokens in a url string */
const useParseTemplateLink = (extraTokensDictionary) => {
    const bapQueryParams = useAppSelector(selectBapUrlQueryString);
    const { dealerCode = '' } = useAppSelector(selectDealer);
    return useCallback((templateLink, query, canUseBapQueryParams) => {
        if (!templateLink)
            return '';
        const url = mergeURLSegments(templateLink, canUseBapQueryParams ? bapQueryParams : query);
        if (canUseBapQueryParams)
            return encodeURLSearchParams(url);
        const tokenDictionary = Object.fromEntries(new URLSearchParams(bapQueryParams).entries());
        return encodeURLSearchParams(constructFromTemplate(url, {
            dealerCode,
            ...tokenDictionary,
            ...extraTokensDictionary,
        }));
    }, [bapQueryParams, extraTokensDictionary, dealerCode]);
};
export default useParseTemplateLink;
